export default class Popup {
    constructor(el) {
        this.DOM = { el };
        this.DOM.closeButton = el.querySelector('.btn-popup-close');
        this.DOM.formToggle = el.querySelector('.btn-popup-form-toggle');
        this.DOM.formWrapper = el.querySelector('.popup-form-wrapper');
        this.storageKey = 'popup-closed';
        this.showAfter = parseInt(el.dataset.showAfter) || 3;

        this.init();
    }

    init() {
        this.initEvents();

        if (this.isPopupClosed()) return this.hidePopup();

        this.DOM.el.hidden = true;
        setTimeout(() => this.showPopup(), this.showAfter * 1000);
    }

    showPopup() {
        this.DOM.el.hidden = false;
        this.DOM.el.style.opacity = '0';
        requestAnimationFrame(() => {
            this.DOM.el.style.opacity = '1';
        });
    }

    initEvents() {
        this.DOM.closeButton?.addEventListener('click', (e) => {
            e.preventDefault();
            this.closePopup();
        });

        this.DOM.formToggle?.addEventListener('click', () => {
            this.toggleForm();
        });
    }

    toggleForm() {
        this.DOM.formWrapper?.classList.toggle('is-open');
    }

    closePopup() {
        this.hidePopup();
        this.setPopupClosed();
    }

    hidePopup() {
        this.DOM.el.style.opacity = '0';
        setTimeout(() => {
            this.DOM.el.hidden = true;
        }, 500);
    }

    isPopupClosed() {
        return sessionStorage.getItem(this.storageKey) === 'true';
    }

    setPopupClosed() {
        sessionStorage.setItem(this.storageKey, 'true');
    }
}
